import { render, staticRenderFns } from "./user-exam.vue?vue&type=template&id=3644469c"
import script from "./user-exam.vue?vue&type=script&lang=js"
export * from "./user-exam.vue?vue&type=script&lang=js"
import style0 from "./user-exam.vue?vue&type=style&index=0&id=3644469c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports